var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 321.93 167.08",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-11,.cls-12,.cls-13,.cls-14,.cls-15,.cls-16,.cls-17,.cls-18,.cls-19,.cls-2,.cls-20,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9{stroke-miterlimit:10;stroke-width:0.23px;}.cls-1{fill:url(#linear-gradient);stroke:url(#New_Gradient_Swatch_4);}.cls-2{fill:url(#linear-gradient-2);stroke:url(#New_Gradient_Swatch_4-2);}.cls-3{fill:url(#linear-gradient-3);stroke:url(#New_Gradient_Swatch_4-3);}.cls-4{fill:url(#linear-gradient-4);stroke:url(#New_Gradient_Swatch_4-4);}.cls-5{fill:url(#linear-gradient-5);stroke:url(#New_Gradient_Swatch_4-5);}.cls-6{fill:url(#linear-gradient-6);stroke:url(#New_Gradient_Swatch_4-6);}.cls-7{fill:url(#linear-gradient-7);stroke:url(#New_Gradient_Swatch_4-7);}.cls-8{fill:url(#linear-gradient-8);stroke:url(#New_Gradient_Swatch_4-8);}.cls-9{fill:url(#linear-gradient-9);stroke:url(#New_Gradient_Swatch_4-9);}.cls-10{isolation:isolate;}.cls-11{fill:url(#linear-gradient-10);stroke:url(#New_Gradient_Swatch_4-10);}.cls-12{fill:url(#linear-gradient-11);stroke:url(#New_Gradient_Swatch_4-11);}.cls-13{fill:url(#linear-gradient-12);stroke:url(#New_Gradient_Swatch_4-12);}.cls-14{fill:url(#linear-gradient-13);stroke:url(#New_Gradient_Swatch_4-13);}.cls-15{fill:url(#linear-gradient-14);stroke:url(#New_Gradient_Swatch_4-14);}.cls-16{fill:url(#linear-gradient-15);stroke:url(#New_Gradient_Swatch_4-15);}.cls-17{fill:url(#linear-gradient-16);stroke:url(#New_Gradient_Swatch_4-16);}.cls-18{fill:url(#linear-gradient-17);stroke:url(#New_Gradient_Swatch_4-17);}.cls-19{fill:url(#linear-gradient-18);stroke:url(#New_Gradient_Swatch_4-18);}.cls-20{fill:url(#linear-gradient-19);stroke:url(#New_Gradient_Swatch_4-19);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 295.35,
    y1: 86.3,
    x2: 295.38,
    y2: 86.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#937c65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#c5a283"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_4",
    x1: 295.25,
    y1: 86.33,
    x2: 295.57,
    y2: 86.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#937c65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c5a283"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 261.33,
    y1: 72.8,
    x2: 289.48,
    y2: 72.8,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_4-2",
    x1: 261.22,
    y1: 72.8,
    x2: 289.65,
    y2: 72.8,
    xlinkHref: "#New_Gradient_Swatch_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 255.96,
    y1: 55.97,
    x2: 321.76,
    y2: 55.97,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_4-3",
    x1: 255.79,
    y1: 55.97,
    x2: 321.93,
    y2: 55.97,
    xlinkHref: "#New_Gradient_Swatch_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 181.53,
    y1: 56.02,
    x2: 246.31,
    y2: 56.02,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_4-4",
    x1: 181.36,
    y1: 56.02,
    x2: 246.48,
    y2: 56.02,
    xlinkHref: "#New_Gradient_Swatch_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 9.78,
    y1: 86.25,
    x2: 9.81,
    y2: 86.25,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_4-5",
    x1: 9.59,
    y1: 86.29,
    x2: 9.91,
    y2: 86.29,
    xlinkHref: "#New_Gradient_Swatch_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 32.46,
    y1: 72.74,
    x2: 60.6,
    y2: 72.74,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_4-6",
    x1: 32.29,
    y1: 72.74,
    x2: 60.71,
    y2: 72.74,
    xlinkHref: "#New_Gradient_Swatch_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 0.17,
    y1: 55.91,
    x2: 65.97,
    y2: 55.91,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_4-7",
    x1: 0,
    y1: 55.91,
    x2: 66.14,
    y2: 55.91,
    xlinkHref: "#New_Gradient_Swatch_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 75.62,
    y1: 55.95,
    x2: 140.4,
    y2: 55.95,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_4-8",
    x1: 75.45,
    y1: 55.95,
    x2: 140.57,
    y2: 55.95,
    xlinkHref: "#New_Gradient_Swatch_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 151.67,
    y1: 55.95,
    x2: 169.37,
    y2: 55.95,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_4-9",
    x1: 151.55,
    y1: 55.95,
    x2: 169.49,
    y2: 55.95,
    xlinkHref: "#New_Gradient_Swatch_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 10.62,
    y1: 146.13,
    x2: 45.19,
    y2: 146.13,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_4-10",
    x1: 10.5,
    y1: 146.13,
    x2: 45.31,
    y2: 146.13,
    xlinkHref: "#New_Gradient_Swatch_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 55.53,
    y1: 146.38,
    x2: 72.57,
    y2: 146.38,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_4-11",
    x1: 55.41,
    y1: 146.38,
    x2: 72.68,
    y2: 146.38,
    xlinkHref: "#New_Gradient_Swatch_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 84.27,
    y1: 140.57,
    x2: 105.64,
    y2: 140.57,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_4-12",
    x1: 84.16,
    y1: 140.57,
    x2: 105.76,
    y2: 140.57,
    xlinkHref: "#New_Gradient_Swatch_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 115.6,
    y1: 140.4,
    x2: 125.6,
    y2: 140.4,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_4-13",
    x1: 115.48,
    y1: 140.4,
    x2: 125.71,
    y2: 140.4,
    xlinkHref: "#New_Gradient_Swatch_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 136.26,
    y1: 146.38,
    x2: 152.97,
    y2: 146.38,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_4-14",
    x1: 136.15,
    y1: 146.38,
    x2: 153.11,
    y2: 146.38,
    xlinkHref: "#New_Gradient_Swatch_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 163.76,
    y1: 146.38,
    x2: 181.96,
    y2: 146.38,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_4-15",
    x1: 163.64,
    y1: 146.38,
    x2: 182.12,
    y2: 146.38,
    xlinkHref: "#New_Gradient_Swatch_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 190.88,
    y1: 140.28,
    x2: 200.88,
    y2: 140.28,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_4-16",
    x1: 190.76,
    y1: 140.28,
    x2: 200.99,
    y2: 140.28,
    xlinkHref: "#New_Gradient_Swatch_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 231.2,
    y1: 146.38,
    x2: 244.58,
    y2: 146.38,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_4-17",
    x1: 231.09,
    y1: 146.38,
    x2: 244.69,
    y2: 146.38,
    xlinkHref: "#New_Gradient_Swatch_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 255.41,
    y1: 151.92,
    x2: 276.78,
    y2: 151.92,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_4-18",
    x1: 255.29,
    y1: 151.92,
    x2: 276.9,
    y2: 151.92,
    xlinkHref: "#New_Gradient_Swatch_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 288.28,
    y1: 146.38,
    x2: 306.48,
    y2: 146.38,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_4-19",
    x1: 288.16,
    y1: 146.38,
    x2: 306.64,
    y2: 146.38,
    xlinkHref: "#New_Gradient_Swatch_4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "295.38 86.32 295.37 86.32 295.35 86.28 295.38 86.32"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "261.33 73.84 262.17 71.74 288.64 71.74 289.48 73.86 275.77 73.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "321.76 111.76 304.75 111.76 303.89 109.67 303.92 109.67 287.02 67.66 286.14 65.49 271.65 29.3 267.88 19.37 257.21 45.32 255.96 45.32 267.49 17.36 273.83 0.18 277.67 0.18 313.73 91.11 321.76 111.76"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "234.74 89.49 236.11 92.68 245.06 71.07 246.31 71.07 236.74 94.28 236.67 94.5 229.65 111.81 225.64 111.81 187.66 15.99 181.53 0.23 198.7 0.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "9.78 86.28 9.79 86.28 9.81 86.23 9.78 86.28"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-6",
    points: "60.6 73.77 59.77 71.68 33.29 71.68 32.46 73.8 46.16 73.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "0.17 111.7 17.18 111.7 18.04 109.6 18.01 109.6 34.91 67.59 35.79 65.42 50.28 29.23 54.05 19.31 64.72 45.25 65.97 45.25 54.44 17.3 48.1 0.12 44.26 0.12 8.2 91.04 0.17 111.7"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-8",
    points: "123.23 0.16 140.4 0.16 134.27 15.92 96.29 111.74 92.28 111.74 85.26 94.43 85.19 94.21 75.62 71 76.87 71 85.82 92.61 87.19 89.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "168.47 111.71 151.67 111.71 152.57 0.19 169.37 0.19 168.47 111.71"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M10.62,154.71h3.2V138h-3.2v-.58h6.7v4.37h.09a7.22,7.22,0,0,1,2.52-3.67,6.73,6.73,0,0,1,4-1.16,7.3,7.3,0,0,1,3.68.91,4.51,4.51,0,0,1,2.11,3h.08a6.64,6.64,0,0,1,.79-1.45,5.57,5.57,0,0,1,1.25-1.27,5.9,5.9,0,0,1,1.77-.9A7.49,7.49,0,0,1,35.9,137q6.09,0,6.09,6.2v11.54h3.2v.59h-10v-.59h3.2V140.55a3,3,0,0,0-.77-2.21,2.77,2.77,0,0,0-2.1-.79,5.69,5.69,0,0,0-2.08.4,5.63,5.63,0,0,0-1.88,1.18,5.91,5.91,0,0,0-1.35,2,7.54,7.54,0,0,0-.52,2.92v10.62h3.21v.59h-10v-.59h3.2V141.13a4.12,4.12,0,0,0-.75-2.71,2.5,2.5,0,0,0-2-.87,5,5,0,0,0-1.91.44,5.8,5.8,0,0,0-1.94,1.37A7.56,7.56,0,0,0,18,141.8a9.89,9.89,0,0,0-.6,3.67v9.24h3.21v.59h-10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M59.73,145c0,.27,0,.56,0,.85s0,.66,0,1.1a26.41,26.41,0,0,0,.17,2.88,8.52,8.52,0,0,0,.73,2.71,5.09,5.09,0,0,0,1.66,2,5,5,0,0,0,2.94.79,7.32,7.32,0,0,0,3-.54,5.53,5.53,0,0,0,1.88-1.32,6,6,0,0,0,1-1.56c.22-.53.39-1,.5-1.29l.62.12a10.43,10.43,0,0,1-.48,1.32,6,6,0,0,1-1.12,1.71,7.08,7.08,0,0,1-2.08,1.49,7.6,7.6,0,0,1-3.4.65,10.7,10.7,0,0,1-3.85-.67,8.58,8.58,0,0,1-5.07-4.89,10.11,10.11,0,0,1-.7-3.85,9.05,9.05,0,0,1,.73-3.57,9.94,9.94,0,0,1,2-3.06,9.81,9.81,0,0,1,3-2.14,8.21,8.21,0,0,1,6.17-.4,7.21,7.21,0,0,1,4.39,3.83,8.47,8.47,0,0,1,.78,3.84Zm8.59-.59a8.6,8.6,0,0,0,.08-1.08v-1a8.5,8.5,0,0,0-.27-2.34,3.74,3.74,0,0,0-.75-1.45,2.64,2.64,0,0,0-1.17-.77,4.46,4.46,0,0,0-1.48-.23,4.35,4.35,0,0,0-2.33.56,4.1,4.1,0,0,0-1.46,1.52,7.8,7.8,0,0,0-.81,2.21,16.72,16.72,0,0,0-.35,2.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M95.64,125.26h6.8v29.45h3.2v.59h-6.7v-3.63h-.09a10.9,10.9,0,0,1-.5,1.21,5.25,5.25,0,0,1-1,1.38,5.85,5.85,0,0,1-1.62,1.14,5.4,5.4,0,0,1-2.4.48,7.91,7.91,0,0,1-3.48-.79A9.76,9.76,0,0,1,87,153a10.2,10.2,0,0,1-2-3.06,9.21,9.21,0,0,1-.73-3.64,9.34,9.34,0,0,1,.71-3.59,9.49,9.49,0,0,1,1.92-3,9.59,9.59,0,0,1,2.79-2,7.64,7.64,0,0,1,3.37-.77A5.78,5.78,0,0,1,96.77,138a6.1,6.1,0,0,1,2,2.75h.08V125.84H95.64Zm-7.2,20.5q0,2.16.12,3.93a10,10,0,0,0,.63,3,3.94,3.94,0,0,0,1.5,1.92,5.72,5.72,0,0,0,5.52-.08,5.06,5.06,0,0,0,1.64-1.94,8.45,8.45,0,0,0,.79-2.65,19.77,19.77,0,0,0,.21-2.83c0-1.08,0-2-.06-2.81a16.64,16.64,0,0,0-.23-2.1,7,7,0,0,0-.46-1.59,6.71,6.71,0,0,0-.71-1.25A4.85,4.85,0,0,0,95.77,138a5.31,5.31,0,0,0-2.54-.54,4.49,4.49,0,0,0-2.4.58,3.83,3.83,0,0,0-1.45,1.67,8.4,8.4,0,0,0-.73,2.6A25.3,25.3,0,0,0,88.44,145.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M115.6,154.71h3.21V138H115.6v-.58h6.79v17.28h3.21v.59h-10Zm2.71-27a2.2,2.2,0,1,1,.64,1.56A2.12,2.12,0,0,1,118.31,127.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M153,150.71q-.14.47-.48,1.32a6,6,0,0,1-1.13,1.71,6.83,6.83,0,0,1-2.08,1.49,7.56,7.56,0,0,1-3.39.65,11.86,11.86,0,0,1-3.3-.5,9.34,9.34,0,0,1-3.12-1.6,8.39,8.39,0,0,1-2.31-2.9,9.73,9.73,0,0,1-.9-4.41,9.39,9.39,0,0,1,.77-3.8,9.81,9.81,0,0,1,2.09-3,9.52,9.52,0,0,1,3.08-2,9.93,9.93,0,0,1,3.77-.73,10.38,10.38,0,0,1,2.31.27,8.09,8.09,0,0,1,2.17.84,5,5,0,0,1,1.62,1.46,3.61,3.61,0,0,1,.65,2.18,2,2,0,0,1-.56,1.44,2.16,2.16,0,0,1-1.61.56,3,3,0,0,1-1.35-.31,1.09,1.09,0,0,1-.65-1.06,4.58,4.58,0,0,1,.29-1.42,4.2,4.2,0,0,0,.3-1.37,1.62,1.62,0,0,0-1-1.48,4.54,4.54,0,0,0-2.21-.52,8,8,0,0,0-1.9.23,3.43,3.43,0,0,0-1.79,1.14,7.11,7.11,0,0,0-1.33,2.75,18.91,18.91,0,0,0-.52,5,22.5,22.5,0,0,0,.23,3.37,9,9,0,0,0,.83,2.78,4.73,4.73,0,0,0,1.67,1.87,5,5,0,0,0,2.77.69,7.32,7.32,0,0,0,3-.54,5.54,5.54,0,0,0,2.89-2.88c.23-.53.39-1,.5-1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M182,154.84a5.65,5.65,0,0,1-1.29.73,4.73,4.73,0,0,1-1.83.31,4.12,4.12,0,0,1-2.9-.85,4.65,4.65,0,0,1-1.23-2.4h-.08c-.11.25-.26.56-.46.94a3.75,3.75,0,0,1-.89,1.08,5.09,5.09,0,0,1-1.61.88,9.67,9.67,0,0,1-5.33-.05,4.55,4.55,0,0,1-1.62-1,2.8,2.8,0,0,1-.77-1.32,5.16,5.16,0,0,1-.19-1.35,4.12,4.12,0,0,1,.58-2.33,4.35,4.35,0,0,1,1.52-1.4,10,10,0,0,1,2.08-.85c.77-.23,1.54-.46,2.32-.71s1.67-.57,2.27-.79a4,4,0,0,0,1.39-.82,2.37,2.37,0,0,0,.69-1.2,8.58,8.58,0,0,0,.19-2,10.65,10.65,0,0,0-.13-1.79,3.64,3.64,0,0,0-.46-1.36,2.13,2.13,0,0,0-1-.85,3.94,3.94,0,0,0-1.67-.29,4.77,4.77,0,0,0-2.27.48,1.64,1.64,0,0,0-.9,1.56,8,8,0,0,0,.13,1.39,6.63,6.63,0,0,1,.12,1,1.31,1.31,0,0,1-.41,1,1.67,1.67,0,0,1-1.21.4c-.92,0-1.49-.17-1.71-.5a2.29,2.29,0,0,1-.33-1.29,4,4,0,0,1,.41-1.75,4.41,4.41,0,0,1,1.23-1.48,6.09,6.09,0,0,1,2-1,9.67,9.67,0,0,1,2.82-.38,9.26,9.26,0,0,1,3.2.48,5.63,5.63,0,0,1,2.09,1.29,4.84,4.84,0,0,1,1.12,1.84,6.9,6.9,0,0,1,.34,2.14V153a2.53,2.53,0,0,0,.37,1.62,1.37,1.37,0,0,0,1.08.42,3,3,0,0,0,1-.17,3.53,3.53,0,0,0,1-.5Zm-7.29-9.75h-.08q-.09.54-1.38,1.08l-3.12,1.25a4.54,4.54,0,0,0-2,1.52,4.09,4.09,0,0,0-.71,2.44,6.42,6.42,0,0,0,.13,1.29,3.27,3.27,0,0,0,.45,1.19,2.58,2.58,0,0,0,.94.85,3.11,3.11,0,0,0,1.56.34,3.87,3.87,0,0,0,2.23-.59,3.73,3.73,0,0,0,1.29-1.45,6.1,6.1,0,0,0,.59-1.9,14.33,14.33,0,0,0,.14-1.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M190.88,154.71h3.21V125.84h-3.21v-.58h6.79v29.45h3.21v.59h-10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M231.2,149.46h.46a17.29,17.29,0,0,0,.75,2,7.38,7.38,0,0,0,1.23,1.87,5.89,5.89,0,0,0,4.6,1.94,3.72,3.72,0,0,0,2.38-.82,3.15,3.15,0,0,0,1-2.64,2.69,2.69,0,0,0-.81-2.23,6.28,6.28,0,0,0-1.9-1l-3.25-1.12c-.41-.14-.86-.32-1.35-.53a4.65,4.65,0,0,1-1.35-.87,4.16,4.16,0,0,1-1-1.44,5.37,5.37,0,0,1-.4-2.25,5,5,0,0,1,.46-2.16,5.44,5.44,0,0,1,1.25-1.75,5.59,5.59,0,0,1,1.89-1.17,6.73,6.73,0,0,1,2.4-.42,6,6,0,0,1,1.48.15c.37.1.7.19,1,.29l.75.29a1.89,1.89,0,0,0,.79.15.73.73,0,0,0,.66-.33h.46v4.74h-.46a17,17,0,0,0-.66-1.77,7.09,7.09,0,0,0-.9-1.52,3.73,3.73,0,0,0-1.29-1,4.09,4.09,0,0,0-1.81-.37,4.88,4.88,0,0,0-3.11.89,3,3,0,0,0-1.1,2.4,2.34,2.34,0,0,0,.94,2,9.77,9.77,0,0,0,2.77,1.27l3,1a8.78,8.78,0,0,1,3.21,1.83,4,4,0,0,1,1.25,3.08,5.88,5.88,0,0,1-.44,2.21,5.26,5.26,0,0,1-1.29,1.9,6.64,6.64,0,0,1-2.08,1.31,7.51,7.51,0,0,1-2.82.5,6.8,6.8,0,0,1-1.68-.19c-.52-.12-1-.25-1.42-.39l-1.19-.4a3.19,3.19,0,0,0-1-.19,1,1,0,0,0-.66.19,2.07,2.07,0,0,0-.34.4h-.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M255.41,166.38h3.21V138h-3.21v-.58h6.71v3.49h.08a6.37,6.37,0,0,1,2.06-2.89,5.83,5.83,0,0,1,3.73-1.15,7.64,7.64,0,0,1,3.37.77,9.77,9.77,0,0,1,2.8,2,9.65,9.65,0,0,1,1.91,3,9.34,9.34,0,0,1,.71,3.59,9.21,9.21,0,0,1-.73,3.64,10.07,10.07,0,0,1-4.87,5.19,7.91,7.91,0,0,1-3.48.79,5.43,5.43,0,0,1-2.4-.48,5.76,5.76,0,0,1-1.6-1.12,5.06,5.06,0,0,1-1-1.34,8.58,8.58,0,0,1-.46-1.1h-.08v14.54h3.21V167h-10Zm17.2-20.62a27.15,27.15,0,0,0-.2-3.44,9,9,0,0,0-.73-2.6,3.92,3.92,0,0,0-1.46-1.67,4.47,4.47,0,0,0-2.4-.58,5.34,5.34,0,0,0-2.54.54,5,5,0,0,0-1.62,1.37,5.11,5.11,0,0,0-.73,1.25,8.23,8.23,0,0,0-.44,1.59,16.64,16.64,0,0,0-.23,2.1c0,.79-.06,1.73-.06,2.81a19.77,19.77,0,0,0,.21,2.83,8.72,8.72,0,0,0,.79,2.65,5.15,5.15,0,0,0,1.64,1.94,4.8,4.8,0,0,0,2.82.75,4.73,4.73,0,0,0,2.7-.67,3.94,3.94,0,0,0,1.5-1.92,9.75,9.75,0,0,0,.63-3Q272.61,147.92,272.61,145.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M306.48,154.84a5.65,5.65,0,0,1-1.29.73,4.73,4.73,0,0,1-1.83.31,4.12,4.12,0,0,1-2.9-.85,4.65,4.65,0,0,1-1.23-2.4h-.08c-.11.25-.26.56-.46.94a3.75,3.75,0,0,1-.89,1.08,5.09,5.09,0,0,1-1.61.88,9.67,9.67,0,0,1-5.33-.05,4.55,4.55,0,0,1-1.62-1,2.8,2.8,0,0,1-.77-1.32,5.16,5.16,0,0,1-.19-1.35,4.12,4.12,0,0,1,.58-2.33,4.35,4.35,0,0,1,1.52-1.4,10,10,0,0,1,2.08-.85c.77-.23,1.54-.46,2.32-.71s1.67-.57,2.27-.79a4,4,0,0,0,1.39-.82,2.37,2.37,0,0,0,.69-1.2,8.06,8.06,0,0,0,.19-2,10.65,10.65,0,0,0-.13-1.79,3.64,3.64,0,0,0-.46-1.36,2.13,2.13,0,0,0-1-.85,3.94,3.94,0,0,0-1.67-.29,4.77,4.77,0,0,0-2.27.48,1.64,1.64,0,0,0-.9,1.56,8,8,0,0,0,.13,1.39,6.63,6.63,0,0,1,.12,1,1.31,1.31,0,0,1-.41,1,1.67,1.67,0,0,1-1.21.4c-.92,0-1.49-.17-1.71-.5a2.29,2.29,0,0,1-.33-1.29,4,4,0,0,1,.41-1.75,4.41,4.41,0,0,1,1.23-1.48,6.29,6.29,0,0,1,2-1,9.67,9.67,0,0,1,2.82-.38,9.26,9.26,0,0,1,3.2.48,5.55,5.55,0,0,1,2.09,1.29,4.84,4.84,0,0,1,1.12,1.84,6.9,6.9,0,0,1,.34,2.14V153a2.53,2.53,0,0,0,.37,1.62,1.37,1.37,0,0,0,1.08.42,3,3,0,0,0,1-.17,3.53,3.53,0,0,0,1-.5Zm-7.29-9.75h-.08c-.06.36-.51.72-1.38,1.08l-3.12,1.25a4.54,4.54,0,0,0-2,1.52,4.09,4.09,0,0,0-.71,2.44,6.42,6.42,0,0,0,.13,1.29,3.27,3.27,0,0,0,.45,1.19,2.58,2.58,0,0,0,.94.85,3.11,3.11,0,0,0,1.56.34,3.87,3.87,0,0,0,2.23-.59,3.73,3.73,0,0,0,1.29-1.45,6.1,6.1,0,0,0,.59-1.9,14.33,14.33,0,0,0,.14-1.85Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.204ef0e3286bde13d202850aa194d51e.svg";
export { ForwardRef as ReactComponent };